import MealPlanAssignmentNotification from './MealPlanAssignmentNotification';

export default MealPlanAssignmentNotification;
